import { render, staticRenderFns } from "./propertyFilters.vue?vue&type=template&id=12f04278&"
import script from "./propertyFilters.vue?vue&type=script&lang=ts&"
export * from "./propertyFilters.vue?vue&type=script&lang=ts&"
import style0 from "./propertyFilters.vue?vue&type=style&index=0&id=12f04278&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports